export const isFullFilledHumidityRoom = (state) => {
  const humidityType = state.humidityRoom.humidityType;

  return !!humidityType
}